/**
 * Function to copy any text or value to clipboard.
 */
export const copyToClipboard = async (val, notify) => {
  try {
    await navigator.clipboard.writeText(val);

    if (notify) {
      notify("Copied to clipboard", {
        variant: "outlined",
        color: "primary",
      });
    }
  } catch (err) {
    if (notify) {
      notify("Failed to copy", {
        variant: "outlined",
        color: "coral_red",
      });
    }

    console.error("Failed to copy to clipboard:", err);
  }
};
